module.exports = __webpack_public_path__ + "media/categories/4001-8b96a03a.svg";